import type {
  SkipSegment,
  SkipSegmentType,
  SkippedInSession,
} from './skip-segment.h'

export function isValidDurationMs(durationMs: number): boolean {
  return Number.isFinite(durationMs) && durationMs > 0
}

export function isValidSegment(
  segment: SkipSegment,
  durationMs: number
): boolean {
  if (!isValidDurationMs(durationMs)) return false
  return segment.showButtonTime < segment.hideButtonTime
}

/** Clamp seek target when API segmentEndTime exceeds player duration (FP-4126). */
export function getSegmentSeekTimeMs(
  segmentEndTimeMs: number,
  durationMs: number
): number {
  if (!isValidDurationMs(durationMs)) return segmentEndTimeMs
  return Math.min(segmentEndTimeMs, Math.ceil(durationMs))
}

function isSegmentSkippedInSession(
  segment: SkipSegment,
  skippedInSession: SkippedInSession
): boolean {
  if (skippedInSession[segment.type]) return true

  if (
    (segment.type === 'CREDITS' || segment.type === 'NEXT_EPISODE') &&
    (skippedInSession.CREDITS || skippedInSession.NEXT_EPISODE)
  ) {
    return true
  }

  return false
}

export function isSegmentVisible(
  segment: SkipSegment,
  currentTimeMs: number,
  durationMs: number,
  skippedInSession: SkippedInSession,
  isAdPlaying: boolean
): boolean {
  if (isAdPlaying) return false
  if (isSegmentSkippedInSession(segment, skippedInSession)) return false
  if (!isValidSegment(segment, durationMs)) return false

  return (
    segment.showButtonTime <= currentTimeMs &&
    currentTimeMs < segment.hideButtonTime
  )
}

export function getActiveSegment(
  segments: SkipSegment[] | undefined,
  currentTimeMs: number,
  durationMs: number,
  skippedInSession: SkippedInSession,
  isAdPlaying: boolean
): SkipSegment | undefined {
  if (!segments?.length) return undefined

  return segments.find((segment) =>
    isSegmentVisible(
      segment,
      currentTimeMs,
      durationMs,
      skippedInSession,
      isAdPlaying
    )
  )
}

export function getSegmentLabelKey(type: SkipSegmentType): string {
  if (type === 'INTRO') return 'skip_intro'
  if (type === 'NEXT_EPISODE') return 'next_episode'
  return 'skip_credits'
}
